export enum ExcelPreviewActionTypes {
  REVIEW = 'review',
  EXPORT = 'export',
}

export enum ExcelEditorActionTypes {
  SAVE = 'save',
  CANCEL = 'cancel',
  CHANGE= 'change',
}

export interface ExcelEditorAction {
  actionType: ExcelEditorActionTypes;
  payload?: { data: string } | null;
}

export interface ExcelPreviewAction {
  actionType: ExcelPreviewActionTypes;
  payload?: { data: string } | null;
}
